export enum DIVISION {
	POST_BRANCH = "PostBranch",
	CARGO_BRANCH = "CargoBranch",
	POSTOMAT = "Postomat",
	PUDO = "PUDO"
}
